module.exports = __webpack_public_path__ + "static/img/Suri-suri 170cm tampak samping.ad46db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Suri-suri 170cm tampak samping.jpg
// module id = 104
// module chunks = 1